import Cookies from 'universal-cookie';

export const canSaveCookie = () => {
  const cookies = new Cookies();
  return (cookies.get('CookieConsent') === 'true');
};


// WEBPACK FOOTER //
// ./src/helpers/cookies/canSaveCookies.ts